import { createInstance } from '@/helpers/api/base'
import { useAppMutation } from '@/helpers/api/mutation'
import { ControlSheetAnnotationDTO } from '@/types/controlsheet'

interface ICreateDutyTimingAnnotationRequest {
    dutyCode: string
    tripNumber: string
    runNumber: string
    route: string
    identifier: string
    startAmendedTime: string | undefined
    departureAmendedTime: string | undefined
}

export const useCreateMealReliefAnnotation = () => {
    const createMealReliefAnnotationMutation = useAppMutation<
        ControlSheetAnnotationDTO,
        Error,
        ICreateDutyTimingAnnotationRequest
    >({
        mutationFn: (data) =>
            createInstance({
                url: `/duty-annotations/meal-relief`,
                method: 'POST',
                data,
            }),
        alertOnError: true,
    })

    const handleCreateMealReliefAnnotationAsync = (
        dutyCode: string,
        tripNumber: string,
        runNumber: string,
        route: string,
        identifier: string,
        startAmendedTime?: string,
        departureAmendedTime?: string
    ) =>
        createMealReliefAnnotationMutation.mutateAsync({
            dutyCode,
            tripNumber,
            runNumber,
            route,
            identifier,
            startAmendedTime,
            departureAmendedTime,
        })

    return {
        handleCreateMealReliefAnnotationAsync,
        isPending: createMealReliefAnnotationMutation.isPending,
        data: createMealReliefAnnotationMutation.data,
        error: createMealReliefAnnotationMutation.error,
    }
}
